// export const API_URL = "https://admin.exsadmin.com/api";
export const API_URL = `${window.location.origin}/api`;

export const IS_ROBOT = false;
